import { render, staticRenderFns } from "./societyNews.vue?vue&type=template&id=7807bde6&scoped=true"
import script from "./societyNews.vue?vue&type=script&lang=js"
export * from "./societyNews.vue?vue&type=script&lang=js"
import style0 from "./societyNews.vue?vue&type=style&index=0&id=7807bde6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7807bde6",
  null
  
)

export default component.exports